import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Calendar } from 'lucide-react';
import Button from '@/components/ui/Button';

const CTASection = () => {
  return (
    <section className="py-20 lg:py-24 bg-slate-900">
      <div className="container px-4 mx-auto">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                Prêt à <span className="text-orcsys-400">transformer</span> votre entreprise ?
              </h2>
              <p className="text-lg text-slate-300 mb-12 max-w-2xl mx-auto">
                Nos professionnels sont disponibles pour échanger sur vos besoins en automatisation 
                et vous proposer des solutions adaptées.
              </p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <Button.Link
                  href="tel:+33123456789"
                  className="min-w-[220px] bg-white text-slate-900 hover:bg-white/90 group"
                  size="lg"
                >
                  <span className="flex items-center">
                    <Phone className="w-4 h-4 mr-2" />
                    Nous appeler maintenant
                  </span>
                </Button.Link>
                
                <Button.Link
                  href="#book"
                  className="min-w-[220px] border-white text-white hover:bg-white/10"
                  variant="outline"
                  size="lg"
                >
                  <span className="flex items-center">
                    <Calendar className="w-4 h-4 mr-2" />
                    Planifier un rendez-vous
                  </span>
                </Button.Link>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection; 